<style scoped>
    .item-title{
        color: #9ba7b5;
    }
    .mail-login{
        display: inline-block;
        vertical-align: middle;
    }
    /*mail*/
    .bizmail_loginpanel{
        font-size:12px;
        width:230px;
        height:auto;
    }
    .bizmail_LoginBox{
        /*padding:10px 15px;*/
    }
    .bizmail_loginpanel h3{
        padding-bottom:5px;
        margin:0 0 5px 0;
        border-bottom:1px solid #cccccc;
        font-size:14px;
    }
    .bizmail_loginpanel form{
        margin:0;padding:0;
    }
    .bizmail_loginpanel input.text{
        font-size:12px;
        width:100px;
        height:20px;
        margin:0 2px;
        border:1px solid #C3C3C3;
        border-color:#7C7C7C #C3C3C3 #C3C3C3 #9A9A9A;
        padding: 0 5px;
        border-radius: 3px;
    }
    .bizmail_loginpanel .bizmail_column{
        height:28px;
    }
    .bizmail_loginpanel .bizmail_column label{
        display:block;
        float:left;
        width:30px;
        height:24px;
        line-height:24px;
        font-size:12px;
    }
    .bizmail_loginpanel .bizmail_column .bizmail_inputArea{
        float:left;
        width:200px;
    }
    .bizmail_loginpanel .bizmail_column span{
        font-size:12px;
        word-wrap:break-word;
        margin-left: 2px;
        line-height:200%;
    }
    .bizmail_loginpanel .bizmail_SubmitArea{
        /*margin-left:30px;*/
        clear:both;
    }
    .bizmail_loginpanel .bizmail_SubmitArea a{
        font-size:12px;
        margin-left:5px;
    }
    .bizmail_loginpanel select{
        width:110px;
        height:20px;
        margin:0 2px;
    }
    .submit-btn{
        width: 132px;
    }
    .forget{
        display: inline-block;
        vertical-align: middle;
    }
</style>
<template>
    <div class="mail-login">
        <Poptip transfer placement="bottom-end">
            <a class="item-title">企业邮箱入口</a>
            <div slot="content" id="divLoginpanelVer" class="bizmail_loginpanel">
                <div class="bizmail_LoginBox">
                    <h3>登录百词斩企业邮箱</h3>
                    <form name="form1" action="https://exmail.qq.com/cgi-bin/login" target="_blank" method="post" onsubmit="return checkInput()">
                        <input type="hidden" name="firstlogin" value="false">
                        <input type="hidden" name="errtemplate" value="dm_loginpage">
                        <input type="hidden" name="aliastype" value="other">
                        <input type="hidden" name="dmtype" value="bizmail">
                        <input type="hidden" name="p" value="">
                        <div class="bizmail_column">
                            <label>帐号:</label>
                            <div class="bizmail_inputArea">
                                <input type="text" name="uin" class="text" value="">@<span>baicizhan.com</span>
                                <input type="hidden" name="domain" value="baicizhan.com">
                            </div>
                        </div>
                        <div class="bizmail_column">
                            <label>密码:</label>
                            <div class="bizmail_inputArea">
                                <input type="password" name="pwd" class="text" value="">
                            </div>
                        </div>
                        <div class="bizmail_SubmitArea" @click="hidePoptip">
                            <input type="submit" class="submit-btn ivu-btn ivu-btn-small" name="" value="登录">
                            <a class="forget" href="https://exmail.qq.com/cgi-bin/readtemplate?check=false&amp;t=bizmail_orz" target="_blank">忘记密码？</a>
                        </div>
                    </form>
                </div>
            </div>
        </Poptip>
    </div>
</template>
<script>
    import Util from '../../../libs/util';
    export default {
        data () {
            return {
                //
            }
        },
        computed: {
            //
        },
        created(){
            //
        },
        mounted(){
            //
        },
        methods: {
            hidePoptip(){
                document.body.click();
            }
        }
    }
</script>
